import artReducer from "@/store/slices/artSlice";
import cartReducer from "@/store/slices/cartSlice";
import colorTemplateReducer from "@/store/slices/colorTemplateSlice";
import dashboardReducer from "@/store/slices/dashboardSlice";
import designerReducer from "@/store/slices/designerSlice";
import imageReducer from "@/store/slices/imageSlice";
import infoReducer from "@/store/slices/infoSlice";
import notesReducer from "@/store/slices/notesSlice";
import productReducer from "@/store/slices/productSlice";
import textReducer from "@/store/slices/textSlice";
import progressReducer from "@/store/slices/progressSlice";
import uploadedArtReducer from "@/store/slices/uploadedArtSlice";
import searchCustomerReducer from "@/store/slices/searchCustomerSlice";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const infoPersistConfig = {
  key: "info",
  storage,
};

const persistedInfoReducer = persistReducer(infoPersistConfig, infoReducer);

export const store = configureStore({
  reducer: {
    art: artReducer,
    cart: cartReducer,
    colorTemplate: colorTemplateReducer,
    dashboard: dashboardReducer,
    designer: designerReducer,
    image: imageReducer,
    info: persistedInfoReducer,
    notes: notesReducer,
    product: productReducer,
    text: textReducer,
    uploadedArt: uploadedArtReducer,
    progress: progressReducer,
    customer: searchCustomerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
